// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-notification {\n  overflow-y: scroll;\n  height: calc(100% - 30px);\n}\n.el-notification__group {\n  width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
